<template>
  <files
    :files='files'
    :title='title'
    :is_uploading='is_uploading'
    @add='addFile'
    :disabled='disabled'
  />
</template>

<script>
import Files from './Files';
import filesAPI from '@/api/files';
import { PROJECT } from '@/api/files';

export default {
  name: 'project-files',
  props: {
    files: {
      required: true
    },
    project_id: {
      required: true
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    title: {
      required: false,
      type: String,
      default: 'Project Files'
    }
  },
  data: () => ({
    file_to_be_uploaded: null,
    is_uploading: false
  }),
  methods: {
    async addFile(file_type, file_to_be_uploaded){
        this.is_uploading = true;
        const response = await filesAPI.getPresignedURL(file_to_be_uploaded.name, PROJECT, this.project_id, file_type);
        await filesAPI.uploadToAWS(response.url, file_to_be_uploaded);
        this.is_uploading = false;
        this.files.push(response.file);
    }
  },
  components: {
    'files': Files
  }
}
</script>
